import makeActionCreator from 'redux/utils/makeActionCreator';
import types from './types';

// Loadings
export const setUser = makeActionCreator(types.SET_USER, 'user');
export const setAuthentication = makeActionCreator(types.SET_AUTHENTICATION, 'authentication');
export const setAppointments = makeActionCreator(types.SET_APPOINTMENTS, 'appointments');
export const setBookingPageURL = makeActionCreator(types.SET_BOOKING_PAGE_URL, 'bookingPageURL');